import { useSelector } from 'react-redux'

import { Divider } from 'antd'
import { faCopy } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import ClickableIcon from '../antd/Buttons/ClickableIcon'
import { onInfo } from '../../utils/apiHelper'

const MetadataDisplayer = ({ metadata }) => {
  const t = useSelector(selectTranslate)
  const visibleMetadata = Object.keys(metadata).reduce((acc, key) => {
    if (metadata[key] !== null && metadata[key] !== undefined) {
      acc.push({ key, value: metadata[key] })
    }

    return acc
  }, [])

  const handleClick = value => {
    navigator.clipboard.writeText(value)
    onInfo(t('common.value_copied'))
  }

  return (
    <div className='metadata-displayer w-100'>
      {visibleMetadata.map(({ key, value }, index) => (
        <div key={index + '_' + key} className='flex-col mb-4 w-100'>
          <strong className='ft-sm'>{t('metadata.' + key)}</strong>
          <Divider style={{ margin: '4px 0' }} />
          <div className='flex-row clickable-line w-100 pd-4' onClick={() => handleClick(value)}>
            {value}
            <div className='ml-4'>
              <ClickableIcon icon={faCopy} title={t('mailing_link.copy_into_clipboard')} />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default MetadataDisplayer
